import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { SuivisService } from 'src/app/data/suivis/services/suivis.service';

@Component({
    selector: 'app-suivis',
    templateUrl: './suivis.component.html',
    styleUrls: ['./suivis.component.scss'],
    standalone: false
})
export class SuivisComponent implements OnInit {
    constructor(private readonly router: Router, public readonly suivisService: SuivisService, private readonly authService: AuthService) {}

    ngOnInit() {
        if (!this.isAnpp()) {
            // this.declarationService.entrepriseSelectionnee=null;
        }
    }

    public onTabChange($event: NgbNavChangeEvent): void {
        switch ($event.nextId) {
            case 'vergers':
                this.router.navigate(['/main/suivis/suivi-inventaires-vergers']);
                break;
            case 'recoltes':
                this.router.navigate(['/main/suivis/suivi-recoltes']);
                break;
            case 'stocks':
                this.router.navigate(['/main/suivis/suivi-stocks']);
                break;
            case 'ecoulements':
                this.router.navigate(['/main/suivis/suivi-ecoulements']);
                break;
            case 'vergersEcoresponsables':
                this.router.navigate(['/main/suivis/suivi-engagements-vergers-ecoresponsables']);
                break;
        }
    }

    isAnpp() {
        return this.authService.isAnpp();
    }
}
